import styled from "styled-components";

export const Avatar = styled.div`
    display: flex;
    margin: 'auto';
    align-items: center;
    justify-content: center;
    /* margin: auto; */
    min-width: 40px;
    width: 40px;
    height: 40px;
    background-color: #E3E48D;
    border: none;
    border-radius: 50%;
    // Position
    position: relative;
    /* top: ${({ top }) => (top ? top : null)}; */
    /* right: ${({ right }) => (right ? right : null)}; */
    /* bottom: ${({ bottom }) => (bottom ? bottom : null)}; */
    /* left: ${({ left }) => (left ? left : null)}; */
    // Transform
    /* transform: ${({ transform }) => (transform ? transform : null)}; */
    // Other
    cursor: pointer;

    &:focus-visible {
        outline: none;
        border: 2px solid #A0DCFF;
    }
`;